import type { CSSProperties } from "react";
import { useAssistantDock } from "../store";
import { useAssistantStatus } from "../hooks";
import { dockAnchored } from "../AssistantDock/dock-modes";

// Reflow do <main> quando o dock abre: padding via CSS var, NUNCA cobre o
// dado operacional. Só no lg (abaixo, o dock é overlay). Devolve a classe + o style para o wrapper.
export function useAssistantReflow(): { className: string; style?: CSSProperties } {
  const open = useAssistantDock((s) => s.open);
  const mode = useAssistantDock((s) => s.mode);
  const size = useAssistantDock((s) => s.size);
  const enabled = useAssistantStatus().data?.enabled ?? false;

  // Floating é sobreposto ⇒ nunca empurra o <main> (só os modos ancorados fazem reflow no lg).
  if (!(enabled && open) || !dockAnchored(mode)) return { className: "" };
  return {
    className: mode === "right" ? "lg:pr-[var(--dock-w)]" : "lg:pb-[var(--dock-h)]",
    style: { "--dock-w": `${size}px`, "--dock-h": `${size}px` } as CSSProperties,
  };
}
